/**
 * ч.1195 (звернення SUP-A034704E): коди сторони у друкованих формах.
 *
 * Юрособа — «ЄДРПОУ 12345678»; ФОП і фізособа — «РНОКПП 1234567890» (той самий
 * реєстраційний номер облікової картки, у побуті «ДРФО»/«ІПН фізособи»);
 * платник ПДВ додатково — «ІПН 123456789012» (індивідуальний податковий номер
 * платника ПДВ: у юрособи = ЄДРПОУ+…, у ФОП раніше 12 цифр, тому з РНОКПП НЕ
 * збігається). До ч.1195 форми друкували лише ЄДРПОУ (у ФОП порожньо) та ІПН.
 * Нерезидент — «Код …» (іноземний реєстраційний номер у полі ЄДРПОУ).
 */
export interface PartyLike {
  edrpou?: string | null;
  inn?: string | null;
  vat_number?: string | null;
  is_vat_payer?: boolean | null;
  entity_type?: string | null;        // організація: 'LEGAL_ENTITY' | 'FOP'
  contractor_type?: string | null;    // контрагент: 'LEGAL' | 'INDIVIDUAL_FOP' | 'INDIVIDUAL' | …
  is_non_resident?: boolean | null;
}

function isIndividual(p: PartyLike): boolean {
  return p.entity_type === 'FOP'
    || p.contractor_type === 'INDIVIDUAL_FOP'
    || p.contractor_type === 'INDIVIDUAL';
}

/** Частини рядка кодів у порядку: ЄДРПОУ/РНОКПП/Код → ІПН платника ПДВ. */
export function partyCodeParts(p: PartyLike | null | undefined): string[] {
  if (!p) return [];
  const parts: string[] = [];
  const edrpou = (p.edrpou ?? '').trim();
  const inn = (p.inn ?? '').trim();
  const vat = (p.vat_number ?? '').trim();
  const individual = isIndividual(p);
  if (edrpou && p.is_non_resident) parts.push(`Код ${edrpou}`);
  else if (edrpou && !individual) parts.push(`ЄДРПОУ ${edrpou}`);
  if (inn && (individual || !edrpou)) parts.push(`РНОКПП ${inn}`);
  if (vat && p.is_vat_payer !== false) parts.push(`ІПН ${vat}`);
  return parts;
}

/** «ЄДРПОУ 12345678, ІПН 123456789012» або '' — зручно для умовного рендеру. */
export function partyCodesText(p: PartyLike | null | undefined, sep = ', '): string {
  return partyCodeParts(p).join(sep);
}

/** ч.1281: власний код організації — у ФОП РНОКПП, у юрособи ЄДРПОУ (дзеркало backend
 *  `services/org_code.own_code`). Для змінної {edrpou} шаблону призначення платежу тощо. */
export function orgOwnCode(o: { entity_type?: string | null; edrpou?: string | null; inn?: string | null } | null | undefined): string | null {
  if (!o) return null;
  const e = (o.edrpou ?? '').trim();
  const i = (o.inn ?? '').trim();
  return (o.entity_type === 'FOP' ? (i || e) : (e || i)) || null;
}
